<ion-header>
  <ion-toolbar>
    <ion-title>{{ 'm/task-process/attach/chatbot-message' | translate }}</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="basicService.dismissModal()">{{ 'm/close' | translate }}</ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ng-container *ngIf="!loading; else loaderTemplateRef">
    <ng-container *ngFor="let item of list">
      <ion-item
        data-testid="agent-shortcut"
        (click)="basicService.dismissModal(item)"
        button
        detail="false"
        lines="full">
        <ion-label class="ion-text-wrap">
          <ion-text color="primary">
            <h2 data-testid="agent-shortcut-name">{{ item.label }}</h2>
          </ion-text>
          <p data-testid="agent-shortcut-scenario-name">{{ item.scenario_label }}</p>
        </ion-label>
      </ion-item>
    </ng-container>
    <div
      *ngIf="!list || !list.length"
      class="no-data-message"
      translate="m/task-process/chatbot-messages/no-chatbot-messages-available"></div>
  </ng-container>
</ion-content>

<ng-template #loaderTemplateRef>
  <div class="spinner">
    <ion-spinner></ion-spinner>
  </div>
</ng-template>
